__webpack_require__.p = "/snake-game/";